export const TASK_TABLE_ROW_ACTIONS_CONFIG = {
  getOnClickProps: item => item,
}
